import { ApiBusinessError } from '@/shared/api/result';
import { t } from '@/shared/i18n/messages';
import { HttpError } from '@/shared/request/http-client';

export type AuthSubmitMode = 'login' | 'register';

export function resolveAuthErrorMessage(error: unknown, mode: AuthSubmitMode) {
  if (error instanceof ApiBusinessError) {
    if (error.code === 'AUTH_IP_DENIED') return t('auth.serverError.ipDenied');

    if (error.code === 'AUTH_USER_NOT_FOUND') {
      return mode === 'register'
        ? t('auth.serverError.registerFailed')
        : t('auth.serverError.userNotFound');
    }

    if (error.code === 'AUTH_ACCOUNT_DISABLED') {
      return t('auth.serverError.accountDisabled');
    }

    if (error.code === 'LOGIN_PASSWORD_INVALID') {
      return t('auth.serverError.passwordInvalid');
    }

    if (error.code === 'AUTH_INVALID') {
      return mode === 'register'
        ? t('auth.serverError.smsCodeInvalid')
        : t('auth.serverError.invalidCredentials');
    }

    if (
      error.code === 'PLAYER_LOGIN_NAME_TAKEN'
      || error.code === 'PLAYER_PHONE_TAKEN'
      || error.code === 'PLAYER_EMAIL_TAKEN'
      || error.code === 'VALIDATION_INVALID'
    ) {
      return mode === 'register'
        ? t('auth.serverError.registerValidation')
        : t('auth.serverError.loginValidation');
    }

    if (error.code === 'TENANT_SCOPE_INVALID') {
      return t('auth.serverError.tenantScope');
    }

    if (error.code === 'SYSTEM_RATE_LIMITED') {
      return t('auth.serverError.rateLimited');
    }
  }

  if (error instanceof HttpError) {
    return t('auth.serverError.unavailable');
  }

  return mode === 'register'
    ? t('auth.serverError.registerFailed')
    : t('auth.serverError.loginFailed');
}
